import { render, staticRenderFns } from "./energyTable.vue?vue&type=template&id=2f6e5c80&scoped=true&"
import script from "./energyTable.vue?vue&type=script&lang=js&"
export * from "./energyTable.vue?vue&type=script&lang=js&"
import style0 from "./energyTable.vue?vue&type=style&index=0&id=2f6e5c80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e5c80",
  null
  
)

export default component.exports